import { render, staticRenderFns } from "./TabelaAtendimentos.vue?vue&type=template&id=1eba85c4&scoped=true"
import script from "./TabelaAtendimentos.vue?vue&type=script&lang=js"
export * from "./TabelaAtendimentos.vue?vue&type=script&lang=js"
import style0 from "./TabelaAtendimentos.vue?vue&type=style&index=0&id=1eba85c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eba85c4",
  null
  
)

export default component.exports